import Vue from "vue";
const Accordion = () => import("@/components/composite/Accordion.vue");
const Card = () => import("@/components/composite/Card/Card.vue");
const TextField = () => import("@/components/TextField.vue");
const Icon = () => import("@/components/Icon/index.vue");
const Button = () => import("@/components/Button.vue");
const CardHeader = () => import("./CardHeader.vue");
const Products = () => import("@/pages/home/_sections/Products.vue");
const CardStep = () => import("./CardStep.vue");
export default Vue.extend({
    components: {
        Card,
        TextField,
        Accordion,
        Icon,
        Button,
        CardHeader,
        Products,
        CardStep,
    },
    props: {
        isActive: Boolean,
    },
    computed: {
        carouselOptions() {
            return {
                slidesPerView: 1.3,
                breakpoints: {
                    640: {
                        slidesPerView: 3.3,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 10,
                    },
                },
            };
        },
        title() {
            return this.isActive
                ? "Gunakan Produk Akun Pembelajaranmu"
                : "Aktifkan dan nikmati kemudahannya";
        },
        description() {
            return this.isActive
                ? "Kini Anda sudah bisa menikmati kemudahan dalam mengakses platform-platform yang dapat mendukung kegiatan belajar mengajar."
                : "Nikmati kemudahan dalam mengakses platform-platform yang dapat mendukung kegiatan belajar mengajar dengan mengaktifkan Akun Pembelajaran Anda. ";
        },
    },
});
